export default __webpack_public_path__ + "static/media/FOTO-4_web.02d2a881.jpg";